import upload_document_form from "./upload_document_form";
export default {
  content: [upload_document_form],
  subtitle: "Here you can upload a document",
  title: "Upload Document",
};
